import { useContext, useState } from 'react';
import { useMutation } from "@apollo/client";
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import EditIcon from '@mui/icons-material/Edit';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import DeleteIcon from '@mui/icons-material/Delete';
import WorkGroupForm from './WorkGroupForm';
import DialogDelete from "../../Utils/DialogDelete"
import {DELETE_WORK_GROUP} from "../../Schema/WorkGroup"
import { AuthContext } from '../../Context/AuthContext';
import { IconButton, Stack, Typography } from '@mui/material';
import {useGetWorkGroupById} from "../../Hooks/useGetWorkGroupById";
import BorderColorIcon from '@mui/icons-material/BorderColor';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';


export default function WorkGroupAction({item, setRefetch}) {

    // Change Language
    const { t, setAlert } = useContext(AuthContext);
    const [loading, setLoading] = useState(false);

    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const {workGroupData, refetchWorkGroupById } = useGetWorkGroupById({id: item?._id})
    
    const handleClose = () => {
        setAnchorEl(null);
    };

    const [openEdit, setOpenEdit] = useState(false);
    const handleOpenEdit = () => {
        refetchWorkGroupById();
        setOpenEdit(true);
        handleClose();

    }
    const handleCloseEdit = () => setOpenEdit(false);

    //Modal delete
    const [openDel, setOpenDel] = useState(false);
    const handleOpenDel = () => setOpenDel(true);
    const handleCloseDel = () => setOpenDel(false);

      const [deleteWorkGroup] = useMutation(DELETE_WORK_GROUP, {
        onCompleted: ({ deleteWorkGroup }) => {
          setLoading(false);
          if (deleteWorkGroup?.isSuccess === true) {
            setAlert(true, "success", deleteWorkGroup?.message);
            handleCloseDel();
            setRefetch();
          } else {
            setAlert(true, "error", deleteWorkGroup?.message);
          }
        },
        onError: (error) => {
          console.log("Error", error?.message);
        },
      });
    
      const handleDelete = () => {
        deleteWorkGroup({
          variables: {
            id: item?._id,
          },
        });
      };

    return (
        <>
            <Stack direction={"row"} justifyContent={'center'} >
                <IconButton onClick={handleOpenEdit}>
                    <BorderColorIcon sx={{ color: "Orange", fontSize: "20px" }} />
                </IconButton>
                <IconButton onClick={handleOpenDel}>
                    <DeleteOutlineIcon sx={{ color: "Red", fontSize: "22px" }} />
                </IconButton>
            </Stack>

            <WorkGroupForm
                open={openEdit}
                editData={workGroupData}
                refetchWorkGroupById={refetchWorkGroupById}
                setRefetch={setRefetch}
                handleClose={handleCloseEdit}
                dialogTitle={"Update"}
            />

            <DialogDelete
                open={openDel}
                handleClose={handleCloseDel}
                loading={loading}
                deleteTitle={t("modal_title_delete_work_group")}
                handleDelete={handleDelete}
                editData={item}
            />
        </>
    )
}